import type { LoggerEvent } from '@/types/logger.types'
import { random } from '@/utils/helpers'

import { AdConsoleLogger } from './utils/ad-console-logger'

export type ClidAccountOverridePayload = {
    account: string | null
    domains: { domain: string; rolloutPercentage: number; hasExternalGpt: boolean }[]
    schain: { asi: string; sid: string } | null
}

export type ClidAccountOverride = {
    gamSubAccount?: string
    useOwnFrameOrigin?: boolean
    hasExternalGpt?: boolean
    schainNode?: { asi: string; sid: string }
}

export type ClidAccountOverrideLogger = { clid: string; logEvent: (event: LoggerEvent) => void }

const adConsoleLogger = new AdConsoleLogger('sdk')

// A host missing from the partner card is not an error for the page: it keeps the Playgama
// account alone, and only a partner with a child network gets told which domain to register.
export function resolveClidAccountOverride(
    { account, domains, schain }: ClidAccountOverridePayload,
    hostname: string,
    logger: ClidAccountOverrideLogger,
): ClidAccountOverride {
    const schainNode = schain ?? undefined
    const host = hostname.replace(/^www\./, '')
    const site = domains.find((entry) => entry.domain === host)
    if (!site) {
        if (account) {
            adConsoleLogger.error(
                `${host} is not registered for clid ${logger.clid}: ads are served without the partner's GAM network, contact support.`,
            )
            logger.logEvent({ event: 'custom_event', eventName: 'ad_sdk_unknown_domain', dimension1: host })
        }
        return { schainNode }
    }

    const isInRollout = !!account && random() * 100 < site.rolloutPercentage
    return {
        ...(account ? { gamSubAccount: isInRollout ? account : undefined, useOwnFrameOrigin: isInRollout } : {}),
        hasExternalGpt: site.hasExternalGpt,
        schainNode,
    }
}
